<mat-expansion-panel
  class="flotante-panel"
  [expanded]="expansionPanelExpanded"
  (expandedChange)="expansionPanelExpanded = $event"
>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <mat-icon class="material-symbols-outlined">emergency</mat-icon>
      <span class="panel-title">Emergencias</span>
      <span class="counter-badge">
        {{ filtradas.length }}
        @if (filtradas.length !== (emergencias?.length ?? 0)) {
          / {{ emergencias?.length ?? 0 }}
        }
      </span>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <!-- BUSCADOR -->
  <div class="seccion top-bar">
    <div class="buscador-wrapper">
      <mat-icon class="search-icon material-symbols-outlined">search</mat-icon>
      <input
        type="text"
        class="buscador-input"
        placeholder="Código, dirección o paciente"
        [(ngModel)]="textoBusqueda"
        (ngModelChange)="onBusquedaChange()"
      />
      @if (textoBusqueda) {
        <button
          irxBotonIcono
          tamano="mini"
          class="clear-btn"
          (click)="limpiarBusqueda()"
          tooltip="Limpiar búsqueda"
        >
          <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
      }
    </div>
  </div>

  <!-- CAPAS -->
  <div class="seccion">
    <div class="seccion-titulo">Capas</div>
    <div class="poligonos-pills">
      <!-- Qué capas se ven: un botón por capa, como "Mostrar" en luminarias -->
      <div class="pill-item">
        <irx-segmentado
          class="visibility-toggle-group"
          tamano="compacto"
        >
          @for (capa of capasConfig; track capa.clave) {
            <irx-segmento
              (click)="toggleCapa(capa.clave)"
              [activo]="capas[capa.clave]"
              [tooltip]="
                (capas[capa.clave] ? 'Ocultar ' : 'Mostrar ') +
                capa.label.toLowerCase() +
                ' (' +
                cantidadCapa(capa.clave) +
                ')'
              "
            >
              <mat-icon class="material-symbols-outlined">{{ capa.icono }}</mat-icon>
            </irx-segmento>
          }
        </irx-segmentado>
        <span class="pill-label">Mostrar</span>
      </div>

      <!-- Qué pinta el ícono de cada emergencia -->
      <div class="pill-item">
        <irx-segmentado
          class="visibility-toggle-group"
          tamano="compacto"
        >
          <irx-segmento
            (click)="setModo('prioridad')"
            [activo]="modo === 'prioridad'"
            tooltip="Pintar las emergencias por código"
          >
            <mat-icon class="material-symbols-outlined">priority_high</mat-icon>
          </irx-segmento>
          <irx-segmento
            (click)="setModo('estado')"
            [activo]="modo === 'estado'"
            tooltip="Pintar las emergencias por estado"
          >
            <mat-icon class="material-symbols-outlined">radio_button_checked</mat-icon>
          </irx-segmento>
        </irx-segmentado>
        <span class="pill-label">Color por</span>
      </div>
    </div>
  </div>

  <!-- CÓDIGOS -->
  <div class="seccion">
    <div class="seccion-titulo seccion-titulo-row">
      <span>Código</span>
      @if (hayPrioridadesFiltradas) {
        <button
          irxBotonIcono
          tamano="mini"
          class="btn-reset-inline"
          (click)="limpiarPrioridades()"
          tooltip="Mostrar todos los códigos"
        >
          <mat-icon class="material-symbols-outlined">refresh</mat-icon>
        </button>
      }
    </div>
    <div
      class="estados-con-dona"
      [class.sin-dona]="!dona || modo !== 'prioridad'"
    >
      @if (dona && modo === 'prioridad') {
        <ng-container [ngTemplateOutlet]="dona"></ng-container>
      }
      <div class="codigos-grid">
        @for (chip of chipsPrioridad; track chip.clave) {
          <button
            type="button"
            class="irx-chip irx-chip--multilinea capa-chip"
            [attr.aria-pressed]="filtrosPrioridad.includes(chip.clave)"
            (click)="togglePrioridad(chip.clave)"
            [tooltip]="chip.label"
          >
            <span class="color-dot" [style.background]="chip.color"></span>
            <span class="capa-label">{{ chip.label }}</span>
            <span class="capa-count">{{ chip.cant }}</span>
          </button>
        }
      </div>
    </div>
  </div>

  <!-- ESTADOS -->
  <div class="seccion">
    <div class="seccion-titulo seccion-titulo-row">
      <span>Estados</span>
      @if (hayEstadosFiltrados) {
        <button
          irxBotonIcono
          tamano="mini"
          class="btn-reset-inline"
          (click)="limpiarEstados()"
          tooltip="Mostrar todos los estados"
        >
          <mat-icon class="material-symbols-outlined">refresh</mat-icon>
        </button>
      }
    </div>
    <div class="estados-con-dona" [class.sin-dona]="!dona || modo !== 'estado'">
      @if (dona && modo === 'estado') {
        <ng-container [ngTemplateOutlet]="dona"></ng-container>
      }
      <div class="estados-grid">
        @for (chip of chipsEstado; track chip.clave) {
          <button
            type="button"
            class="irx-chip irx-chip--multilinea capa-chip estado-chip"
            [attr.aria-pressed]="estadoActivo(chip.clave)"
            (click)="toggleEstado(chip.clave)"
            [tooltip]="chip.label"
          >
            <span class="estado-icon-bg">
              <mat-icon class="material-symbols-outlined estado-icon" [style.color]="chip.color">{{ chip.icono }}</mat-icon>
            </span>
            <span class="capa-label">{{ chip.label }}</span>
            <span class="capa-count">{{ chip.cant }}</span>
          </button>
        }
      </div>
    </div>
  </div>

  @if (hayFiltrosActivos) {
    <button
      irxBoton="secundario"
      type="button"
      class="limpiar-btn"
      (click)="limpiarFiltros()"
    >
      <mat-icon class="material-symbols-outlined">filter_alt_off</mat-icon>
      Limpiar todo
    </button>
  }
</mat-expansion-panel>
